import { useQueryParamsV6 } from "./hooks/useQueryParams/useQueryParams";
import { RVNonRouterGrid } from "./RVNonRouterGrid/RVNonRouterGrid";

import type { GridProps } from "./RVGridTypes";

/**
 * Default data table for routed pages (`src/Pages/**` components rendered via `Routes.tsx`).
 *
 * Syncs pagination, sorting, and filters to the URL via `useQueryParamsV6`. Supports infinite scroll
 * and cursor pagination via `infiniteScroll` + `getMoreRows` (set `pagination={false}` and
 * `useQueryParamsUrl={false}` when the backend owns paging).
 *
 * @remarks Prefer this over {@link RVNonRouterGrid} whenever the grid lives inside React Router
 * context. Do not manually call `useQueryParamsV6` and pass `uiQueryParams` / `setUiQueryParams` —
 * that duplication is what this wrapper exists to avoid.
 *
 * @see {@link RVNonRouterGrid} for modals and other trees outside router context.
 */
export function RVGrid(props: GridProps): JSX.Element {
    const { setUiQueryParams, uiQueryParams } = useQueryParamsV6(props.defaultParams);
    return <RVNonRouterGrid {...props} setUiQueryParams={setUiQueryParams} uiQueryParams={uiQueryParams} />;
}
